module.exports = __webpack_public_path__ + "static/kelly-Normal-e618e9f034d0736c225f205db9015b4c.jpg";